import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '../styles/movieDetail.css';
import Navbar from './Navbar';
import Footer from './footer';

const MovieDetail = () => {
  const { movieId } = useParams();
  const [movieDetails, setMovieDetails] = useState(null);

  useEffect(() => {
    const fetchMovieDetails = async () => {
      try {
        const response = await fetch(`https://api.themoviedb.org/3/movie/${movieId}?api_key=133b03fa38dce6887c1086a85641ce9a`);
        if (!response.ok) {
          throw new Error('Movie not found');
        }
        const data = await response.json();
        setMovieDetails(data);
      } catch (error) {
        console.error("Failed to fetch movie details:", error);
      }
    };

    fetchMovieDetails();
  }, [movieId]);

  if (!movieDetails) {
    return <div>Loading...</div>;
  }

  return (
    <div className='Detail'>
    <Navbar />
    <div className="movie-detail-container">
      {/* <h1 className='DetailTitle'>{movieDetails.title}</h1> */}
        <img data-aos="fade-in" className="DetailImg"src={`https://image.tmdb.org/t/p/w500${movieDetails.poster_path}`} alt={movieDetails.title} />
        <span className='DetailP' data-aos="fade-up">{movieDetails.overview}</span>
    </div>
    <Footer />
    </div>
  );
};

export default MovieDetail;
